import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Search from '@mui/icons-material/Search';
import Settings from '@mui/icons-material/Settings';

interface TopNavBarProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const TopNavBar: React.FC<TopNavBarProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: 48,
        background: 'linear-gradient(135deg, #004D40 0%, #00796B 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        px: 1.5,
      }}
    >
      {/* Left side: Logo + Label */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: 1,
            backgroundColor: 'rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            S5
          </Typography>
        </Box>
        <Typography
          sx={{
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            mr: 2,
          }}
        >
          View Configuration
        </Typography>
      </Box>

      {/* Center: Tab buttons */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          gap: 0.5,
          overflow: 'hidden',
        }}
      >
        {tabs.map((tab) => {
          const isActive = tab === activeTab;
          return (
            <Button
              key={tab}
              onClick={() => onTabChange(tab)}
              disableRipple={false}
              sx={{
                color: isActive ? '#fff' : 'rgba(255,255,255,0.75)',
                backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
                borderBottom: isActive ? '3px solid #A5D6A7' : '3px solid transparent',
                borderRadius: 0,
                fontWeight: isActive ? 600 : 400,
                fontSize: 13,
                whiteSpace: 'nowrap',
                textTransform: 'none',
                px: 2,
                py: 0.75,
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: isActive
                    ? 'rgba(255,255,255,0.15)'
                    : 'rgba(255,255,255,0.08)',
                },
              }}
            >
              {tab}
            </Button>
          );
        })}
      </Box>

      {/* Right side: Search + Settings */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.12)',
            borderRadius: 1,
            px: 1,
            py: 0.25,
          }}
        >
          <Search sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 18, mr: 0.5 }} />
          <InputBase
            placeholder="Search views..."
            sx={{
              color: '#fff',
              fontSize: 13,
              '& ::placeholder': {
                color: 'rgba(255,255,255,0.5)',
                opacity: 1,
              },
            }}
            inputProps={{ 'aria-label': 'search views' }}
          />
        </Box>
        <IconButton size="small" sx={{ color: 'rgba(255,255,255,0.75)' }}>
          <Settings sx={{ fontSize: 20 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TopNavBar;
